
import Vue from 'vue'


import { module as button } from './button.js'
import { module as pop } from './pop.js'


class Store {
    constructor (params) {
        Object.assign(this, { state: {}, actions: {}, mutations: {} })
        Object.keys(params.modules).forEach(key => {
            Object.assign(this.state, Vue.observable(Object.assign(params.state || {}, this._handleState(key, params.modules[key].state || {}))))
            Object.assign(this.mutations, Object.assign(params.mutations || {}, this._handleMutations(key, params.modules[key].mutations || {})))
            Object.assign(this.actions, Object.assign(params.actions || {}, this._handleActions(key, params.modules[key].actions || {})))
        })
    }
    commit (fun, params) {
        let arr = fun.split('/')
        arr.pop()
        let obj = arr.reduce((a, b) => a[b], this.state)
        this.mutations[fun](obj || this.state, params)
    }
    dispatch (fun, params) {
        this.actions[fun](this.state, params)
    }
    _handleState (namespaced, state) {
        let obj = {}
        obj[namespaced] = {}
        let state$ = Object.keys(state).reduce((a, b) => {
            a[namespaced][b] = state[b]
            return a
        }, obj)
        return state$
    }
    _handleMutations (namespaced, mutations) {
        let mutations$ = Object.keys(mutations).reduce((a, b) => {
            a[namespaced + '/' + b] = mutations[b]
            return a
        }, {})
        return mutations$
    }
    _handleActions (namespaced, actions) {
        let actions$ = Object.keys(actions).reduce((a, b) => {
            a[namespaced + '/' + b] = actions[b]
            return a
        }, {})
        return actions$
    }
}












export const store = new Store({
    modules: {
        button,
        pop
    },
})
